module.exports = __webpack_public_path__ + "img/process.9b4c156d.png";